import { render, staticRenderFns } from "./warningRecordList-dialog.vue?vue&type=template&id=4a959546&scoped=true"
import script from "./warningRecordList-dialog.vue?vue&type=script&lang=js"
export * from "./warningRecordList-dialog.vue?vue&type=script&lang=js"
import style0 from "./warningRecordList-dialog.vue?vue&type=style&index=0&id=4a959546&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a959546",
  null
  
)

export default component.exports